export class ProcedurePerformanceLine {
  id:number;
  centerLatitude:number;
  centerLongitude:number;
  centerHeigth:number;
  centerValue:number;
  centerNseValue:number;
  worstValue:number;
  worstNseValue:number;
  receiverDelay:number;
  distance : number;
}
